import { z } from "zod";

export const LeadSourceSchema = z.enum([
	"unknown",
	"facebook",
	"instagram",
	"google",
	"referral",
	"organic",
	"phone",
	"event",
	"other",
]);
export type TLeadSource = z.infer<typeof LeadSourceSchema>;

/** Hebrew display labels. Index by the persisted code. */
export const LEAD_SOURCE_LABELS_HE: Record<TLeadSource, string> = {
	unknown: "לא ידוע",
	facebook: "פייסבוק",
	instagram: "אינסטגרם",
	google: "גוגל",
	referral: "המלצה",
	organic: "אורגני",
	phone: "טלפון",
	event: "אירוע",
	other: "אחר",
};

/** Iterable list of all lead sources with their labels — handy for dropdown options. */
export const LEAD_SOURCE_OPTIONS: ReadonlyArray<{ code: TLeadSource; label: string }> =
	LeadSourceSchema.options.map((code) => ({ code, label: LEAD_SOURCE_LABELS_HE[code] }));

export const AdminClientActivityTypeSchema = z.enum([
	"note",
	"call",
	"email",
	"meeting",
	"status_change",
	"other",
]);
export type TAdminClientActivityType = z.infer<typeof AdminClientActivityTypeSchema>;

export const AdminClientActivitySchema = z.object({
	id: z.string(),
	type: AdminClientActivityTypeSchema,
	message: z.string(),
	createdAt: z.number(),
	createdBy: z.string().optional(),
});
export type TAdminClientActivity = z.infer<typeof AdminClientActivitySchema>;

export const AdminClientDataSchema = z.object({
	id: z.string(),
	adminComment: z.string().optional(),
	leadSource: LeadSourceSchema.optional(),
	userActivity: z.array(AdminClientActivitySchema).optional(),
	updatedAt: z.number().optional(),
});
export type TAdminClientData = z.infer<typeof AdminClientDataSchema>;
